import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

/* eslint-disable no-debugger */

if (localStorage.getItem("principal") && JSON.parse(localStorage.getItem("principal")).token) {
	axios.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(localStorage.getItem("principal")).token;
}
console.log('axios authorization: ' + axios.defaults.headers.common['Authorization']);

export default new Vuex.Store({
	state: {
		principal: (localStorage.getItem("principal") && JSON.parse(localStorage.getItem("principal"))) || {},
		notification: {
			title: null,
			content: {},
			show: false
		},
		auditorium: {
			tab: 0,
			panel: 0,
			url: null
		},
		toggleLiveNotification: null,
		webSocket: {
			host: null,
			isConnected: false,
			message: '',
			reconnectError: false,
		},
		webSocketNotification:{
			show: false,
			message: '',
			link: ''
		},
		isPoweredBy: localStorage.getItem("isPoweredBy") == null ? false : (localStorage.getItem("isPoweredBy") === "true"),
		isUseCometChat: localStorage.getItem("isUseCometChat") == null ? false : (localStorage.getItem("isUseCometChat") === "true"),
		showNetworkingLounge: localStorage.getItem("showNetworkingLounge") == null ? false : (localStorage.getItem("showNetworkingLounge") === "true"),
		showVideoTransition: localStorage.getItem("showVideoTransition") == null ? false : (localStorage.getItem("showVideoTransition") === "true"),
		isFitToWidth: localStorage.getItem("isFitToWidth") == null ? null : (localStorage.getItem("isFitToWidth") === "true"),
		domainThatUseAliases: ['estrogeniq.com','estrogeniq.test.v-unite.com'],
        footerText: localStorage.getItem("footerText") ? localStorage.getItem("footerText") : "",
	},
	mutations: {
		login(state, principal) {
			console.log('mutation: login before state: ' + JSON.stringify(state) + " principal: " + JSON.stringify(principal));
			state.principal = principal;
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + principal.token;
			localStorage.setItem("principal", JSON.stringify(principal));
			console.log('mutation: login after state: ' + JSON.stringify(state, null, 4));
			state.showNetworkingLounge = false;
		},
		logout(state) {
			console.log('mutation: logout before state: ' + JSON.stringify(state));
			state.principal = {};
			delete axios.defaults.headers.common['Authorization'];
			localStorage.removeItem("principal");
			localStorage.removeItem("showNetworkingLounge");
			localStorage.removeItem("showVideoTransition");
			localStorage.removeItem("isFitToWidth");
			state.isFitToWidth = false;
			console.log('mutation: logout after state: ' + JSON.stringify(state));
		},
		showNotification(state, { title, content, withoutTitle }) {
			state.notification.title = title;
			state.notification.content = content;
			state.notification.show = true;
			state.notification.withoutTitle = withoutTitle == null ? false : withoutTitle;
		},
		hideNotification(state) {
			state.notification.show = false;
			state.notification.title = null;
			state.notification.content = {};
		},
		resetLiveNotification(state) {
			state.toggleLiveNotification = null;
		},
		showLiveNotification(state) {
			state.toggleLiveNotification = true;
		},
		hideLiveNotification(state) {
			state.toggleLiveNotification = false;
		},
		debug(state) {
			console.log("localStorage principal: " + localStorage.getItem("principal") + " state: " + JSON.stringify(state, null, 4));
		},
		// used to update user profile
		updatePrincipal(state, user) {
			let principal = JSON.parse(localStorage.getItem("principal"));
			principal.firstName = user.firstName;
			principal.lastName = user.lastName;
			principal.title = user.title;
			principal.bio = user.bio;
			principal.medspaToken = user.medspaToken;
			principal.image = user.image + (user.image ? '?' + new Date().getSeconds() : '');
			state.principal = principal;
			localStorage.setItem("principal", JSON.stringify(principal));
		},
		// Vue Native Websocket Feature
		SOCKET_ONOPEN(state, event) {
			Vue.prototype.$socket = event.currentTarget;
			state.webSocket.isConnected = true;
			console.log("Notification session detected");
		},
		SOCKET_ONCLOSE(state) {
			state.webSocket.isConnected = false;
		},
		SOCKET_ONERROR(state, event) {
			console.error(state, event);
		},
		// default handler called for all methods
		SOCKET_ONMESSAGE(state, message) {
			state.webSocket.message = message;
			if(message.message){
				state.webSocketNotification.show = true;
				state.webSocketNotification.message = message.message;
				state.webSocketNotification.link = message.link;
			}
		},
		// mutations for reconnect methods
		SOCKET_RECONNECT(state, count) {
		console.info(state, count);
		},
		SOCKET_RECONNECT_ERROR(state) {
			state.webSocket.reconnectError = true;
		},
		setIsPoweredBy(state, isPoweredBy) {
			state.isPoweredBy = isPoweredBy;
			localStorage.setItem("isPoweredBy", isPoweredBy);
		},
        setFooterText(state, footerText) {
			state.footerText = footerText;
			localStorage.setItem("footerText", footerText);
		},
		setIsUseCometChat(state, isUseCometChat) {
			state.isUseCometChat = isUseCometChat;
			localStorage.setItem("isUseCometChat", isUseCometChat);
		},
		setShowNetworkingLounge(state, showNetworkingLounge) {
			state.showNetworkingLounge = showNetworkingLounge;
			localStorage.setItem("showNetworkingLounge", showNetworkingLounge);
		},
		setShowVideoTransition(state, showVideoTransition) {
			state.showVideoTransition = showVideoTransition;
			localStorage.setItem("showVideoTransition", showVideoTransition);
		},
		setFitToWidth(state, isFitToWidth) {
			state.isFitToWidth = isFitToWidth;
			localStorage.setItem("isFitToWidth", isFitToWidth);
		}
	},
	actions: {
		login({ commit }, principal) {
			console.log('action: login');
			return new Promise((resolve, reject) => {
				axios.post(
					"/system/authentication/login",
					{
						tenantPlanId: principal.tenantPlanId,
						type: principal.type,
						email: principal.email,
						password: principal.password,
						tenantSlug: principal.tenantSlug,
						experienceSlug: principal.experienceSlug,
						tenantId: principal.tenantId
					}
				).then(response => {
					let principal = response.data;
					principal.image = principal.image + (principal.image ? '?' + new Date().getSeconds() : '');
					if (principal && principal.token) {
						commit('login', principal);
						resolve({response:response, principal:principal});
					}
				}).catch(error => reject(error));
			});
		},
		logout({ commit }) {
			console.log('action: logout');
			return new Promise((resolve, reject) => {
				axios.post(
					"/system/authentication/logout",
					{}
				).then(response => {
					commit('logout');
					resolve(response);
				}).catch(error => reject(error));
			});
		},
		debug({ commit }) {
			console.log('action: debug');
			commit('debug');
		}
	},
	getters: {
		isLoggedIn: state => (state.principal && state.principal.token)
	},
})